/* ============================================================================
   PRESSA — MOTION & CRAFT BEHAVIOUR
   ----------------------------------------------------------------------------
   Builds the grain, turns the hero photo into a parallax layer, and runs the
   considered arrival. Styling lives in pressa-motion.css. Guarded so it can't
   break the page. (Trailing cursor and magnetic buttons removed by request.)
   ============================================================================ */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var body   = document.body;

  /* ---- filmic grain ---- */
  var grain = document.createElement('div');
  grain.className = 'pr-grain';
  grain.setAttribute('aria-hidden', 'true');
  body.appendChild(grain);

  /* ---- hero: build a parallax layer from the section's background photo ---- */
  var hero = document.querySelector('.pr-hero');
  var bg = null;
  if (hero) {
    var img = getComputedStyle(hero).backgroundImage;
    if (img && img !== 'none') {
      bg = document.createElement('div');
      bg.className = 'pr-hero__bg';
      bg.style.backgroundImage = img;
      hero.style.backgroundImage = 'none';
      hero.insertBefore(bg, hero.firstChild);
    }
    /* considered arrival */
    hero.classList.add('is-ready');
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { hero.classList.add('is-arrived'); });
    });
  }

  /* ---- hero parallax (drift the photo slower than the scroll) ---- */
  if (bg && !reduce) {
    var ticking = false;
    function parallax() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var y = window.scrollY || document.documentElement.scrollTop || 0;
        bg.style.transform = 'translate3d(0,' + (y * 0.15).toFixed(1) + 'px,0)';
        ticking = false;
      });
    }
    window.addEventListener('scroll', parallax, { passive: true });
    parallax();
  }

})();


/* ============================================================================
   FUN EMAIL PLACEHOLDER  (self-contained, delete to revert)
   ============================================================================ */
(function () {
  'use strict';
  var PLACEHOLDER = 'your@email.com';
  document.querySelectorAll('.pr-form__input').forEach(function (input) {
    input.placeholder = PLACEHOLDER;
  });
})();


/* ============================================================================
   FOUNDER SIGNATURE IMAGE  (self-contained, delete to revert)
   ============================================================================ */
(function () {
  'use strict';
  var SIG_URL = 'https://cdn.shopify.com/s/files/1/0764/0570/2796/files/signature-founders.png?v=1782795225';
  var sig = document.querySelector('.pr-founders__sign');
  if (sig && !document.querySelector('.pr-founders__sign-img')) {
    var img = document.createElement('img');
    img.className = 'pr-founders__sign-img';
    img.src = SIG_URL;
    img.alt = sig.textContent || 'Founders signature';
    sig.replaceWith(img);
  }
})();


/* ============================================================================
   COPY TWEAKS  (self-contained, delete to revert)
   ============================================================================ */
(function () {
  'use strict';
  var daily = document.querySelector('.pr-card--daily .pr-card__origin');
  if (daily) daily.textContent = 'West Wimmera, Inland Victoria';

  var harvest = document.querySelector('.pr-card--harvest .pr-card__origin');
  if (harvest) harvest.textContent = 'The Bellarine, Coastal Victoria';

  var freshSub = document.querySelector('.pr-fresh__sub');
  if (freshSub) freshSub.textContent = 'Most supermarket oil was pressed over a year before it hits the shelf. Drag the slider and find out where yours sits. No date on the bottle? Drag all the way.';
})();


/* ============================================================================
   PRODUCT BADGES  (self-contained, delete to revert)
   ----------------------------------------------------------------------------
   Adds a small badge above each product name: 'Everyday' on Pressa Daily and
   'Release No. 1' on the Harvest Series.
   ============================================================================ */
(function () {
  'use strict';
  function addBadge(sel, text, cls) {
    var card = document.querySelector(sel);
    if (!card) return;
    var name = card.querySelector('.pr-card__name');
    if (!name || card.querySelector('.pr-release-badge')) return;
    var badge = document.createElement('span');
    badge.className = 'pr-release-badge' + (cls ? ' ' + cls : '');
    badge.textContent = text;
    name.parentNode.insertBefore(badge, name);
  }
  addBadge('.pr-card--harvest', 'Release No. 1', '');
  addBadge('.pr-card--daily', 'Everyday', 'pr-release-badge--daily');
})();


/* ============================================================================
   FRESHNESS SLIDER FILL  (self-contained, delete to revert)
   ============================================================================ */
(function () {
  'use strict';
  var r = document.querySelector('.pr-fresh__range');
  if (!r) return;
  var FILL = '#F2D45C', TRACK = 'rgba(43,27,4,0.12)';
  function paint() {
    var pct = (r.value - r.min) / (r.max - r.min) * 100;
    r.style.background = 'linear-gradient(to right, ' + FILL + ' 0%, ' + FILL + ' ' + pct + '%, ' + TRACK + ' ' + pct + '%, ' + TRACK + ' 100%)';
  }
  r.addEventListener('input', paint);
  paint();
})();


/* ============================================================================
   SECTION ORDER  (self-contained, delete to revert)
   ----------------------------------------------------------------------------
   Puts the founders note after the social 'Follow along' section, giving the
   order: products · freshness · social · founders · launch. Moves the founders
   node (not the social one) so the Instagram feed inside social is untouched.
   ============================================================================ */
(function () {
  'use strict';
  var social = document.querySelector('.pr-social');
  var founders = document.querySelector('.pr-founders');
  if (social && founders && social.parentNode) {
    social.parentNode.insertBefore(founders, social.nextSibling);
  }
})();
